module.exports = __webpack_public_path__ + "application/directives/svg-image/pdf-svg/pdf-svg.template.html";